import * as z from 'zod';

export const removalCauseQuerySchema = z.enum(['Damaged', 'Lost/Stolen', 'Donated', 'Expired/Nonrelevant']);

type RemovalCauseQuerySchema = z.infer<typeof removalCauseQuerySchema>;
export type RemovalCauseMutationSchema = RemovalCauseQuerySchema;

export const removalCauseFormSchema = z.object({
  name: z.string(),
  value: removalCauseQuerySchema,
});

type RemovalCauseFormSchema = z.infer<typeof removalCauseFormSchema>;

export const defaultRemovalCause = null;

export const removalCauseOptions: RemovalCauseFormSchema[] = [
  { name: 'Damaged', value: 'Damaged' },
  { name: 'Lost/Stolen', value: 'Lost/Stolen' },
  { name: 'Donated', value: 'Donated' },
  { name: 'Expired/Nonrelevant', value: 'Expired/Nonrelevant' },
];

export function strToRemovalCause(rc: RemovalCauseQuerySchema | null): RemovalCauseFormSchema | null {
  return removalCauseOptions.find((option) => option?.value === rc) ?? null;
}

export function removalCauseToStr(rc: RemovalCauseFormSchema | null) {
  return rc?.value ?? null;
}
